import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import httpInterceptor from '../common/APIConfig'


const initialState = {
    addUserMessage: null,
    loading: false,
    isSuccess: false,
    error: false,
    errorMessage: null
}

export const addUser = createAsyncThunk(
     'addUser',
      async (data, {rejectWithValue}) => {

      const body = {
        'email': data.user_email,
        'role': data.user_role
      }
      
    try {
        const response = await httpInterceptor.post(`/admin/users`, body)
        if (response.status === 200) {
            return response.data
        }
    } catch (error){
            console.log(error)
            if (!error.response){
                return rejectWithValue(error.message) 
            }
            return rejectWithValue(error.response.data)
        }
  })

export const addUserSlice = createSlice({
    name: 'addUser',
    initialState,
    error: null,
    reducers: {
        resetAddUser: state => {
            state.addUserMessage = null
            state.loading = false
            state.isSuccess = false
            state.error = false
            state.errorMessage = null
        },
        resetAddUserError: state => {
            state.error = false
            state.errorMessage = null
        }
    },
    extraReducers: builder => {
        builder.addCase(addUser.pending, (state) => {
            state.loading = true
        })
        builder.addCase(addUser.fulfilled, (state, action) => {
            state.loading = false
            state.addUserMessage = "User added successfully!"//action.payload.message
            state.isSuccess = true
            state.error = false
        })
        builder.addCase(addUser.rejected, (state, action) => {
            state.loading = false
            state.errorMessage = "Something went wrong while adding the user." //action.payload.message
            state.error = true
        })
    }
})

export const { resetAddUser, resetAddUserError } = addUserSlice.actions

export default addUserSlice.reducer